import { LuTrendingDown, LuTrendingUp } from 'react-icons/lu';

import { ChartRendererProps } from '../../types/chart-renderer-props';
import { PeriodComparisonListItem, toPeriodComparisonListItems } from '../../utils/to-period-comparison-list-items';
import { useUnknownChartSeriesLabel } from '../shared/use-chart-series-display-name';

export interface PeriodChangeListChartProps extends ChartRendererProps {
    direction?: 'up' | 'down';
    limit?: number;
}

const trendClassName = (direction: 'up' | 'down' | 'flat'): string => {
    if (direction === 'up') {
        return 'text-status-success';
    }

    if (direction === 'down') {
        return 'text-status-warning';
    }

    return 'text-brand-muted';
};

const rankItems = (items: PeriodComparisonListItem[], direction?: 'up' | 'down', limit?: number): PeriodComparisonListItem[] => {
    const filtered = direction ? items.filter((item) => item.direction === direction) : items;
    const ranked = [...filtered].sort((left, right) => (right.percentChange ?? -1) - (left.percentChange ?? -1));

    return typeof limit === 'number' ? ranked.slice(0, limit) : ranked;
};

export const PeriodChangeListChart = ({ data, className, direction, limit }: PeriodChangeListChartProps) => {
    const unknownLabel = useUnknownChartSeriesLabel();
    const items = rankItems(toPeriodComparisonListItems(data, unknownLabel), direction, limit);

    return (
        <div className={`flex w-full flex-col items-stretch justify-start gap-3 self-stretch ${className ?? ''}`}>
            {items.map((item) => (
                <div
                    key={item.key}
                    className='flex w-full items-center justify-between'>
                    <div className='flex min-w-0 flex-1 flex-col items-start justify-center gap-0.5'>
                        <div className='text-foreground-default justify-start text-base font-semibold'>{item.value}</div>
                        <div className='text-brand-muted justify-start text-base font-medium'>{item.name}</div>
                    </div>
                    {item.percentChange !== null && (
                        <div className={`flex shrink-0 items-center gap-1 text-base font-semibold ${trendClassName(item.direction)}`}>
                            {item.direction === 'down' && <LuTrendingDown className='size-5' />}
                            {item.direction === 'up' && <LuTrendingUp className='size-5' />}
                            {item.percentChange}%
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};
